/* import __COLOCATED_TEMPLATE__ from './font-family.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { EMBERCOM_PROSEMIRROR_COMPOSER_ALLOW_MOUSEDOWN_CLASS } from '@intercom/embercom-prosemirror-composer/components/editor-api/constants';
import { FONT_FAMILIES_DATA } from '@intercom/embercom-prosemirror-composer/lib/blocks/constants';
let FontFamily = (_class = class FontFamily extends Component {
  get allow_mousedown_class() {
    return EMBERCOM_PROSEMIRROR_COMPOSER_ALLOW_MOUSEDOWN_CLASS;
  }
  get fontFamilies() {
    if (!this.args.composer.config.customStylesConfig?.allowFontFamilyInTextFormatter) {
      return [];
    }
    return FONT_FAMILIES_DATA;
  }
  get selectedFontFamily() {
    let selectedValue = this.args.composer.state.selectionAnchorNodeFontFamily || '';
    return this.fontFamilies.filter(item => item.value === selectedValue)[0].text;
  }
  changeFontFamily(fontFamily) {
    if (!this.args.composer) {
      return;
    }
    this.args.composer.config.analytics?.trackAnalyticsEvent('edited', {
      block_type: this.args.composer.state.selectionAnchorNodeType.name,
      font_family: fontFamily
    });
    this.args.composer.commands.styling.updateFontFamily(fontFamily, true);
    this.args.composer.commands.focus();
  }
}, (_applyDecoratedDescriptor(_class.prototype, "changeFontFamily", [action], Object.getOwnPropertyDescriptor(_class.prototype, "changeFontFamily"), _class.prototype)), _class);
export { FontFamily as default };